import { Box } from "@mui/material";
import { Heading3, Text1 } from "../styled";
import { useFormContext } from "react-hook-form";

interface Props {
  workTitle: string;
}

const TopCard = ({ workTitle }: Props) => {
  const { watch } = useFormContext();
  const { workLocation } = watch();

  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        maxWidth: "400px",
        textAlign: "center",
      }}
    >
      <Box sx={{ position: "relative" }}>
        <img
          src="https://static.uat.helppoydin.com/email/email_banner.png"
          alt="Eezy banner"
          style={{
            width: "400px",
            height: "200px",
            objectFit: "cover",
          }}
        />
        <img
          src="https://static.uat.helppoydin.com/email/email_eezy_logo.png"
          alt="Company Logo"
          style={{
            width: "56px",
            height: "56px",
            position: "absolute",
            bottom: "-28px",
            left: "50%",
            transform: "translateX(-50%)",
            borderRadius: "50%",
            border: "4px solid #ffffff",
          }}
        />
      </Box>
      <Box sx={{ padding: "32px 16px 16px" }}>
        <Heading3>{workLocation?.name || ""}</Heading3>
        <Text1 sx={{ color: "#696969" }}>
          {`${workTitle || ""}${workTitle && workLocation?.address?.city ? "," : ""} ${workLocation?.address?.city || ""}`}
        </Text1>
      </Box>
    </Box>
  );
};

export default TopCard;
